import logoWhite from 'assets/images/logo-white.png'

const Logo = ({ width = 120 }) => {
    return <img src={logoWhite} alt="SpokingPolls" width={width} />
}

export default Logo
